export default __webpack_public_path__ + "3b5eefc86321f4072fad77a9ca018a91.webp";